import { produce } from 'immer';
import { useEffect, useState } from 'react';
import { useGetInvoicesQuery } from '../../store/api-generated';
import divideArrayIntoParts from '../../helpers/divideArrayIntoParts';

const MAX_INVOICES_PER_PAGE = 10;

export default function usePaginatedInvoices(accountId?: string) {
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setCurrentPage(1);
  }, [accountId]);

  const { data: invoices = [], isLoading, isError } = useGetInvoicesQuery({
    accountId: accountId!,
  }, {
    skip: !accountId,
  });

  const sortedInvoices = produce(invoices, (draft) => {
    return draft.sort((a, b) => {
      return new Date(b.creationDate!).getTime() - new Date(a.creationDate!).getTime();
    });
  });

  const dividedInvoices = divideArrayIntoParts(sortedInvoices, MAX_INVOICES_PER_PAGE);

  const pagination = {
    totalPages: dividedInvoices.length,
    totalInvoices: sortedInvoices.length,
    currentPage,
    setCurrentPage,
  };

  return {
    invoices: dividedInvoices?.[currentPage - 1] || [],
    pagination,
    isLoading,
    isError,
  } as const;
}
